var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17C2.8 17 2.2 16.8 1.8 16.4C1.7 16.3 1.6 16.2 1.5 16.1C0.8 15.5 0 14.7 0 13.7C0 13 0.5 12.3 1.3 11.6C3.6 9.7 4.6 10.4 5.8 11.6L6 11.8C6.1 11.9 6.5 11.8 7.1 11.4C7.7 11 8.5 10.3 9.4 9.4C12.2 6.6 11.8 6 11.8 6L11.6 5.8C10.4 4.7 9.8 3.7 11.6 1.3C12.3 0.5 13 0 13.7 0C14.7 0 15.5 0.8 16.1 1.4C16.2 1.5 16.3 1.6 16.4 1.7C17.2 2.5 17.2 4 16.4 5.9C15.6 7.9 14.1 10.1 12.1 12.1C9 15.4 5.6 17 3.5 17ZM3.7 11.4C3.3 11.4 2.7 11.7 1.9 12.3C1.3 12.9 1 13.3 1 13.7C1 14.3 1.6 14.9 2.1 15.4C2.2 15.5 2.3 15.6 2.4 15.7C3.2 16.5 7.2 15.8 11.5 11.5C13.4 9.6 14.8 7.5 15.5 5.6C16.1 3.9 16 2.8 15.7 2.4C15.6 2.3 15.5 2.2 15.4 2.1C14.9 1.6 14.3 1 13.7 1C13.3 1 12.8 1.3 12.4 1.9C10.9 3.7 11.4 4.1 12.3 5L12.5 5.2C13.4 6.1 12.6 7.6 10.1 10.1C9.1 11.1 8.3 11.8 7.6 12.2C6.5 12.9 5.7 13 5.2 12.5L5 12.3C4.6 11.8 4.2 11.4 3.7 11.4Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b46e004600445a752a0ea85e85f7c524.svg";
export { ForwardRef as ReactComponent };